import { NgModule } from '@angular/core';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        // Distinct storage key so this public app's tokens don't collide with the
        // internal suite (also clientId jissu-uaa, no configId) on the shared origin.
        configId: 'jissu-public-dm-dc',
        authority: environment.oidc.authority,
        clientId: environment.oidc.clientId,
        scope: environment.oidc.scope,

        redirectUrl: environment.oidc.redirectUrl,
        postLogoutRedirectUri: environment.oidc.postLogoutRedirectUri,

        responseType: 'code',
        silentRenew: true,

        ignoreNonceAfterRefresh: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 120,
        tokenRefreshInSeconds: 15,

        autoUserInfo: true,
        unauthorizedRoute: '/domov/unauthorized',
        forbiddenRoute: '/domov/forbidden',

        // triggerAuthorizationResultEvent: true,
        logLevel: LogLevel.Warn,

        secureRoutes: environment.oidc.secureRoutes, // this tells interceptor to send accessToken
      },
    }),
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
